<template>
  <div class="pt-3">
    <div class="col col-md-6 offset-md-3">
      <div class="card">
        <div class="card-header d-flex align-items-center">
          <h3>{{ msg }}</h3>
        </div>
        <div class="card-body">
          <form @submit="login">
            <div class="container">
              <div class="d-flex flex-column gap-2">
                <div class="row">
                  <div class="col">
                    <input
                      v-model="organization"
                      class="form-control"
                      placeholder="organization"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input
                      v-model="username"
                      class="form-control"
                      placeholder="username"
                      autocomplete="username"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input
                      v-model="password"
                      class="form-control"
                      type="password"
                      placeholder="password"
                      autocomplete="current-password"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <button
                      v-if="!loading"
                      class="btn btn-secondary"
                      @click="signOut"
                    >
                      Logout
                    </button>
                  </div>
                  <div class="col">
                    <LoadingSpinner
                      v-if="loading"
                      :active="loading"
                      spinner="bar-fade-scale"
                      class="mt-5"
                    />
                    <button
                      v-if="!loading"
                      class="btn btn-primary"
                      type="submit"
                      @click="login($event)"
                    >
                      Login
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <p v-if="error" class="alert alert-danger mt-5">
                      {{ error.message }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Amplify } from 'aws-amplify'
import { get } from 'aws-amplify/api'
import {
  getCurrentUser,
  fetchAuthSession,
  signIn,
  signOut
} from 'aws-amplify/auth'
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue'
import { useUserStore } from '@/stores/user-store'
import { useSurveysStore } from '@/stores/surveys-store'
import { useResultsStore } from '@/stores/results-store'
import { useStatesStore } from '@/stores/states-store'
import { currentCredentials } from '@/services/aws-amplify-service'

export default {
  name: 'Login',
  components: {
    LoadingSpinner
  },
  setup() {
    const userStore = useUserStore()
    const surveysStore = useSurveysStore()
    const resultsStore = useResultsStore()
    const statesStore = useStatesStore()
    return { userStore, surveysStore, resultsStore, statesStore }
  },
  data() {
    return {
      cognitoUser: {},
      msg: 'Login',
      organization: '',
      username: '',
      password: '',
      newPassword: '',
      error: null,
      loading: false
    }
  },
  async mounted() {
    if (this.statesStore.organizationName) {
      // for our convenience
      this.organization = this.statesStore.organizationName
    }

    this.statesStore.$reset()
    this.surveysStore.$reset()
    this.resultsStore.$reset()
  },
  methods: {
    async fetchPublicAPIData() {
      let res = null
      try {
        const restOperation = get({
          apiName: 'PublicAPI',
          path: `/organizations/${this.organization}`
        })
        res = await restOperation.response
      } catch (e) {
        console.error(e)
        this.loading = false
        this.password = ''
        this.error = new Error(e.response?.statusCode)
        return null
      }
      return res.body.json()
    },
    updateState(orgResult) {
      const organizationGroup = {
        name: this.organization,
        messages: {
          en: {
            title: this.$t('general.entireOrganization')
          }
        }
      }
      this.statesStore.setOrganizationName(this.organization)
      this.statesStore.setOrganizationGroup(organizationGroup)
      this.statesStore.setSelectedGroup(organizationGroup)
      localStorage.orgData = JSON.stringify(orgResult)
      this.statesStore.setAttributesForResults(orgResult.attributes)
    },

    async login(e) {
      // to stop submit event/enter from refreshing page
      e.preventDefault()
      this.error = null
      this.loading = true

      // try {

      const orgResult = await this.fetchPublicAPIData()
      if (!orgResult) {
        return
      }

      this.updateState(orgResult)

      const existingConfig = Amplify.getConfig()
      const amplifyConfig = {
        ...existingConfig,
        Auth: {
          Cognito: {
            region: 'eu-west-1',
            userPoolId: orgResult.userPoolId,
            userPoolClientId: orgResult.userPoolWebClientId
          },
          identityPoolId: orgResult.identityPoolId,
          region: 'eu-west-1'
        }
      }
      Amplify.configure(amplifyConfig)

      try {
        await signOut() // cannot sign in unless we're signed out
      } catch (e) {
        // error signing out, but we dont care
      }
      // }
      signIn({
        username: this.username,
        password: this.password,
        options: {
          authFlowType: 'USER_SRP_AUTH',
          clientMetadata: {
            organizationName: this.organization,
            organizationFullName: orgResult.organizationFullName,
            locale: 'en'
          }
        }
      })
        .then(({ isSignedIn, nextStep }) => {
          if (isSignedIn) {
            this.loading = false
            this.userStore.setHasToken(true)
            return currentCredentials().then((user) => {
              this.userStore.setLoggedInUser(user)
              this.$router.push('/')
            })
          }
        })
        .catch((err) => {
          console.error('err', err)
          this.loading = false
          this.password = ''
          this.error = err
        })
      // } catch (err) {
      //   console.error('err', err)
      //   this.loading = false
      //   this.password = ''
      //   this.error = err
      // }
    }
  }
}
</script>
